setTimeout(() => {
	const rewardsExist = document.querySelector('.rewards-balance-container');
	if (rewardsExist) {
		function animateBar() {
			const rewardsBar = document.querySelector('.point-count');
			const theValue = rewardsBar.getAttribute('data-value');
			rewardsBar.setAttribute('value', theValue);	
			$({countNum: $('.counter').text()}).animate({countNum: theValue}, {
				duration: 1500,
				easing:'linear',
				step: function() {
					$('.counter').text(Math.floor(this.countNum));
				},
				complete: function() {
					$('.counter').text(this.countNum);
				}
			});
			
		}
		animateBar();
	}
}, 1000)